import React, { useState } from 'react';

const AboutUsCard = () => {
  const [active] = useState('aboutus');
  const [isHovered, setIsHovered] = useState(false);

  const content = {
    aboutus: [
      {
        models: [
          {
            description: 'About Us',
            link: {
              url: '/AboutUsHome',
            },
          },
          {
            description: 'Our Clients',
            link: {
              url: '/OurClients',
            },
          },
          {
            description: 'Careers',
            link: {
              url: '/Careers',
            },
          },
        ],
      },
    ],
  };

  const handleItemClick = (url) => {
    window.location.href = url; // Navigate to the respective URL
    window.close();             // Close the current window
  };

  return (
    <div className="relative group">
      <div 
        onMouseEnter={() => setIsHovered(true)} 
        onMouseLeave={() => setIsHovered(false)}
      >
        <button
          className={`relative px-2 py-2 text-gray-600 bg-white rounded ease-in-out transform focus:outline-none font-normal 
            after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-[2px] after:transition-all after:duration-3000 
            ${isHovered ? 'hover:scale-110 after:bg-blue-500 after:w-full' : 'after:bg-transparent'}`}
        >
          About Us
        </button>
        <div className="fixed right-2/1 transform -translate-y-2/1 mt-0.5 bg-white rounded-md hidden group-hover:block text-justify max-w-[90vw] sm:max-w-[80vw] lg:max-w-[70vw] z-50 overflow-y-auto max-h-[80vh]">
          <div className="p-4 flex flex-col lg:flex-row text-justify h-auto">

            <div className="flex-grow p-4 overflow-x-auto lg:overflow-visible">
              <div className="flex flex-wrap lg:flex-nowrap lg:space-x-4">
                {content[active].map((item, index) => (
                  <div key={index} className="w-full sm:w-1/1 md:w-1/1 lg:w-3/1 bg-white rounded-lg overflow-hidden mb-4">
                    <div className="p-4">
                      {item.models.map((model, idx) => (
                        <div 
                          key={idx} 
                          className="mb-2 cursor-pointer"
                          onClick={() => handleItemClick(model.link.url)}
                        >
                          <p className="text-gray-500 hover:text-blue-700 text-md font-normal">
                            {model.description}
                          </p>
                        </div>
                      ))}
                    </div>
                    <hr />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsCard;
